import { FC } from 'react';
import { PredefinedColors } from '@ionic/core';
import { IonButton, IonIcon } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';

export const MenuBackButton: FC<{
    onClick?: () => void;
    color?: PredefinedColors;
}> = ({ onClick, color }) => {
    return (
        <IonButton
            color={color}
            shape="round"
            onClick={onClick}
            data-id="back-button"
        >
            <IonIcon icon={arrowBack} />
        </IonButton>
    );
};
